import React from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { DownloadRounded } from "@mui/icons-material";
import FileTypeIcon from "./FileTypeIcon";

export default function FileRow({ name, ext, onDownload, iconSize = 56 }) {
  return (
    <Grid2
      container
      alignItems="center"
      spacing={2}
      wrap="nowrap"
      sx={{
        p: 1.5,
        bgcolor: "background.paper",
      }}
    >
      {/* Left: Icon */}
      <Grid2>
        <FileTypeIcon ext={ext} size={iconSize} />
      </Grid2>

      {/* Right: name (top) + download button (bottom) */}
      <Grid2 sx={{ minWidth: 0 }} flexGrow={1}>
        <Box sx={{ display: "grid", gridTemplateRows: "auto auto", rowGap: 0.5 }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            noWrap
            title={name}
            sx={{ lineHeight: 1.2 }}
          >
            {name}
          </Typography>

          <Button
            variant="contained"
            size="small"
            startIcon={<DownloadRounded />}
            onClick={onDownload}
            sx={{ width: "fit-content" }}
          >
            Download
          </Button>
        </Box>
      </Grid2>
    </Grid2>
  );
}
